import { Outlet } from "react-router-dom";

import { ToastProvider } from "@/lib/components/ui/Toast";

import { App } from "../App";
import styles from "./layout.module.scss";

export const RootLayout = (): JSX.Element => {
  return (
    <div className={styles.body}>
      <ToastProvider>
        <App>
          <Outlet />
        </App>
      </ToastProvider>
    </div>
  );
};
